import * as Yup from 'yup';
import { SORTBY_OPTIONS, dlcTypes } from '../../utils/constants';
import SelectQuestion from '../SelectQuestion/SelectQuestion';
import { createLocalizedOptions } from '../../pages/root/App';
import messages from './messages';
import siteMessages from '../../pages/root/siteMessages';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  values: any;
  errors: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
}

const DlcContents = ({
  values,
  errors,
  setFieldValue,
  updateSchema
}: Props) => {
  const intl = useIntl();

  const dlcTypesOptions = createLocalizedOptions(
    dlcTypes,
    messages,
    SORTBY_OPTIONS.Name
  );

  useEffect(() => {
    const dlcContentsSchema = {
      dlcTypeIds: Yup.array(Yup.number()).min(
        1,
        intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
      )
    };
    updateSchema(dlcContentsSchema);
  }, []);

  return (
    <SelectQuestion
      controlId="dlcTypeIds"
      label={intl.formatMessage({ ...messages.dlcTypes })}
      isMulti={true}
      options={dlcTypesOptions}
      value={values.dlcTypeIds}
      error={errors.dlcTypeIds}
      setFieldValue={setFieldValue}
    />
  );
};

export default DlcContents;
